import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { useMemo } from 'react';
import { useIsRowLayoutMode } from '../hooks/useIsRowLayoutMode';
import { selectIsTourneyRoom } from '../redux/selectorFns';
import { useAppSelector } from '../redux/store';
import { HEADER_BACKGROUND_COLOR, TOURNEY_HEADER_BACKGROUND_COLOR } from '../styles/colors';
export const HeaderContainer = ({ children }) => {
    const isTourneyRoom = useAppSelector(selectIsTourneyRoom);
    const isRowLayoutMode = useIsRowLayoutMode();
    const containerCss = useMemo(() => css `
      background-color: ${isTourneyRoom ? TOURNEY_HEADER_BACKGROUND_COLOR : HEADER_BACKGROUND_COLOR};
      display: flex;
      border-bottom: ${isRowLayoutMode ? '1px solid black' : 'none'};
      /* z-index here allows the header to render on top of panels, so any panel animations will appear under the header rather than on top. */
      z-index: 1;
    `, [isRowLayoutMode, isTourneyRoom]);
    return _jsx("div", { css: containerCss, children: children });
};
